import React from 'react';
import styled, { keyframes } from 'styled-components';

const logosCarrosel1 = [
  '/img/logos/mysql.svg',
  '/img/logos/javascript.svg',
  '/img/logos/php.svg',
  '/img/logos/react.svg',
  '/img/logos/typescript.svg',
];

const logosCarrosel2 = [
  '/img/logos/jquery.svg',
  '/img/logos/azure.svg',
  '/img/logos/python.svg',
  '/img/logos/node.js.svg',
  '/img/logos/ejs.svg',
];

const logosCarrosel3 = [
  '/img/logos/java.svg',
  '/img/logos/html.svg',
  '/img/logos/css.svg',
  '/img/logos/wordpress.svg',
];

// a trilha tem a lista duplicada; andar -50% cai exatamente no início da cópia,
// então o loop não tem emenda visível (diferente do slick, que salta para os clones)
const rolar = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const Wrapper = styled.div`
  margin-bottom: 40px;
  overflow: hidden;
  mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);
`;

const Trilha = styled.div`
  display: flex;
  width: max-content;
  animation: ${rolar} ${(props) => props.$duracao}s linear infinite;
  animation-direction: ${(props) => (props.$reverso ? 'reverse' : 'normal')};
  will-change: transform;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const ImageSlide = styled.div`
  flex-shrink: 0;
  width: 140px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  @media (min-width: 996px) {
    width: 160px;
  }

  img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
  }
`;

const SEGUNDOS_POR_LOGO = 2;

const Esteira = ({ logos, reverso }) => {
  const grupo = [...logos, ...logos];

  return (
    <Wrapper>
      <Trilha $reverso={reverso} $duracao={grupo.length * SEGUNDOS_POR_LOGO}>
        {[...grupo, ...grupo].map((logo, i) => (
          <ImageSlide key={i} aria-hidden={i >= grupo.length}>
            <img src={logo} alt={i < grupo.length ? logo.split('/').pop().replace('.svg', '') : ''} />
          </ImageSlide>
        ))}
      </Trilha>
    </Wrapper>
  );
};

const CarrosselMultiplo = () => (
  <>
    <Esteira logos={logosCarrosel1} />
    <Esteira logos={logosCarrosel2} reverso />
    <Esteira logos={logosCarrosel3} />
  </>
);

export default CarrosselMultiplo;
